import Quill from 'quill';

const SizeClass = Quill.import('attributors/class/size');
SizeClass.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];

const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];

export { SizeClass, SizeStyle };
